<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <h3>ANÁLISIS DE LABORATORIO DE TICKETS</h3>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-sm btn-primary float-right" v-if="analisis_id == null" @click="crearAnalisis">CREAR</button>
                        <button class="btn btn-sm btn-primary float-right" v-if="analisis_id != null" @click="actualizarAnalisis">ACTUALIZAR</button>
                    </div>
                    <!-- <pre>Analisis: {{analisis}}</pre> -->
                </div>
                <!-- <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                                <label for="form-control-label">Seleccione Ticket</label>
                                <v-select class="" @input="cargar_analisis" @search="cargarTicket" :reduce="option => option.id" v-model="tickets_id" :options="tickets" label="codigo_ticket">
                                    <template v-slot:no-options="{ search, searching }">
                                    <template v-if="searching">
                                        No se Encontraron Resultados Para <em>{{ search }}</em>.
                                    </template>
                                    <em style="opacity: 0.5;" v-else>Escriba para Filtrar Ticket...</em>
                                    </template>
                                </v-select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group">
                                <label for="form-control-label">Seleccione Guía</label>
                                <select class="form-control" name="" id="" v-model="guias_id" @change="cargar_analisis">
                                    <option v-for="g in guias" :key="g.id" :value="g.id">{{g.numero_guia}}</option>
                                </select>
                        </div>
                    </div>
                    <div class="col-md-3">
                        
                        <div class="form-group">
                                <label for="form-control-label">Materia Prima</label>
                                <input class="form-control" type="text" v-model="materia_prima" disabled>
                        </div>
                    </div>
                    <div class="col-md-3">
                        <button class="btn btn-sm btn-primary" v-if="analisis_id == null" @click="crearAnalisis">Crear</button>
                        <button class="btn btn-sm btn-primary" v-if="analisis_id != null" @click="actualizarAnalisis">Actualizar</button>
                    </div>
                </div> -->

                <div class="row">
                    <div class="col">
                        <div class="card">
                            <table class="table table-bordered">
                                <thead class="thead-blue1">
                                    <tr>
                                        <th class="text-center">TICKET</th>
                                        <th class="text-center">FECHA TICKET</th>
                                        <th class="text-center">MATERIA PRIMA</th>
                                        <th class="text-center">PATENTE</th>

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            
                                            <v-select class="mb-2" @input="cargar_analisis" @search="cargarTicket" :reduce="option => option.id" v-model="tickets_id" :options="tickets" label="codigo_ticket">
                                                <template v-slot:no-options="{ search, searching }">
                                                <template v-if="searching">
                                                    No se Encontraron Resultados Para <em>{{ search }}</em>.
                                                </template>
                                                <em style="opacity: 0.5;" v-else>Escriba para Filtrar Ticket...</em>
                                                </template>
                                            </v-select>
                                            
                                        </td>
                                        <td><span class="text-center" v-if="ticket">{{ticket.fecha_hora_ticket | fecha_hora}}</span></td>
                                        <td><span class="text-center" v-if="ticket">{{ticket.materia_prima_texto}}</span></td>
                                        <td><span class="text-center" v-if="ticket">{{ticket.patente}}</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


                <div class="row">
                    <div class="col">
                        <div class="alert alert-warning alert-dismissible fade show" role="alert" v-if="alert">
                            <span class="alert-icon"><i class="fas fa-exclamation-triangle"></i></span>
                            <!-- <span class="alert-text"><strong>Error de Validación!</strong></span> -->
                            <span class="alert-text" v-for="(m,index) in mensaje_alert" :key="index"> <strong>{{`${m},`}}</strong></span>
                            
                            <button type="button" class="close" @click="alert = !alert" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col">
                        <table class="table table-bordered">
                            <thead class="thead-blue1">
                                <tr>
                                    <th class="text-center">N° GUÍA</th>
                                    <th class="text-center">PROVEEDOR</th>
                                    <th class="text-center">SUCURSAL</th>
                                    <!-- <th class="text-center">PESO ROMANA (KG)</th> -->

                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="g in guias" :key="g.id">
                                    <td class="text-center">
                                        {{g.numero_guia}}
                                    </td>
                                    <td class="text-center">{{g.empresa_texto}}</td>
                                    <td class="text-center">{{g.sucursal_texto}}</td>
                                    <!-- <td class="text-center">{{g.peso_real}}</td> -->
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <!-- <pre>{{items_analisis}}</pre> -->
        <!-- <pre>{{items}}</pre> -->
        <!-- <pre>{{parametros}}</pre> -->
        <div class="card" v-show="analisis_id != null">
            <div class="card-body">
                <div class="row" v-for="item in items" :key="item.id">
                    <table class="table table-bordered">
                        <thead class="background-salmon-3">
                            <tr>
                                <th :colspan="item.cantidad_parametros"><strong>{{item.nombre}}</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td v-for="(par,idx) in devolver_parametros(item.id)" :key="idx">
                                    <div class="form-group">
                                        <label for="form-control-label mr-3"><strong>{{`${par.nombre} ${par.unidad_medida_texto}`}}</strong><span v-if="par.maximo != '-'" style="padding-left:10px;"> ( máx. {{`${par.maximo}`}} ) </span></label>
                                        <input v-if="par.tipo_dato_texto == 'Numero'" :class="[{'form-control':true,'input-rojo-1':calcular_alerta(par)}]" type="number" v-model="par.valor">
                                        <input v-if="par.tipo_dato_texto == 'Texto'" :class="[{'form-control':true}]" type="text" v-model="par.valor_texto">
                                        <textarea class="form-control" v-if="par.tipo_dato_texto == 'Textarea'" name="" id="" cols="30" rows="5" v-model="par.valor_texto"></textarea>
                                        <input v-if="par.tipo_dato_texto == 'Archivo'" type="file" @change="subirArchivo($event,par)">
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- <pre>{{parametros}}</pre> -->
    </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
    data:()=>({
        tickets:[],
        guias:[],
        disabled_guia:true,
        analisis_id:null,
        tickets_id:null,
        guias_id:null,
        ticket:{},
        //guia_id:undefined,
        items_analisis:[],
        parametros:[],
        analisis:null,
        detalles:[],
        errores:{},
        alert:false
    }),
    mounted(){

    },
    methods:{
        async cargarTicket($event){
            if($event != ''){
                await this.axios.get(`${this.api}/tickets?codigo_ticket=${$event}&ciclo_ticket=1`,this.cabeceras_json).then((res)=>{
                    this.tickets = res.data.data.data;
                    //this.guia_id = undefined;
                    ////console.log('tickets',res.data.data);
                }).catch((e)=>{
                    //console.log(e);
                });
            }
            
        },

        async cargar_guias(){
            await this.axios.get(`${this.api}/guias?tickets_id=${this.tickets_id}&&limit=9999999`,this.cabeceras_json).then(async(res)=>{
                ////console.log(res.data.data.data);
                this.guias = res.data.data.data;
                //await this.cargarParametrosMateriaPrima();
                //await this.cargar_analisis();
            }).catch((e)=>{
                //console.log(e);
            });
        },
        async cargarGuias(){
            //console.log('tickets_id',this.tickets_id);
            //limpiando el analisis
            //this.analisis_id = null;
            //this.tickets_id = null;
            //this.guias_id = null;
            //this.analisis = null;
            //this.parametros = [];


            //this.analisis.tickets_id = this.tickets_id;
            if(this.tickets_id != null){
                this.ticket = this.tickets.find(t => t.id == this.tickets_id);
                await this.cargarParametrosMateriaPrima();
                //this.ticket = ticket?ticket:{};
                if(this.ticket.mp_tipos_id  == 2){
                    this.cargar_analisis();
                }
                
                //cargando guias
                await this.axios.get(`${this.api}/guias?tickets_id=${this.tickets_id}`,this.cabeceras_json).then(async(res)=>{
                    ////console.log(res.data.data.data);
                    this.guias = res.data.data.data;
                    //await this.cargarParametrosMateriaPrima();
                    //await this.cargar_analisis();
                }).catch((e)=>{
                    //console.log(e);
                });
            }else{
                this.guias = [];
                this.items_analisis = [];
                this.analisis = null;
                this.analisis_id = null;
                this.tickets_id = null;
                this.guias_id = null;

            }
        },

        async crearAnalisis(){
            let body = {
                tickets_id:this.tickets_id,
                //guias_id:this.guias_id
            };

            await this.axios.post(`${this.api}/lab_analisis`,body,this.cabeceras_json).then((res)=>{
                //console.log('res_analisis',res.data.data);
                if(res.data.codigo == 200){
                    this.alert = false;
                    this.errores = {};
                    this.analisis = res.data.data;
                    this.analisis_id = this.analisis.id;
                    this.tickets_id = this.analisis.tickets_id;
                    this.guias_id = this.analisis.guias_id;
                }else{
                    //error de validacion
                    this.errores = res.data.data;
                    this.alert = true;
                    this.analisis = null;
                    this.analisis_id = null;
                    //console.log('error validacion',res.data);
                }
            }).catch((e)=>{
                //console.log(e);
            });
            this.setearParametros();
        },

        calcular_alerta(parametro){
            let minimo = parametro.valor_minimo;
            let maximo = parametro.valor_maximo;
            let valor = parametro.valor;
            let alerta = false;
            
            if(minimo != null && maximo != null){
                alerta =  valor < minimo || valor > maximo ? true :false
            }
            else if(minimo != null && maximo == null){
                alerta =  valor < minimo? true:false;
            }

            else if(minimo == null && maximo != null){
                alerta =  valor > maximo? true:false;
            }

            if(valor == null || valor == ''){
                alerta = false;
            }
            return alerta;
            //return valor < minimo || valor > maximo ? true:false;
        },

        async actualizarAnalisis(){
            let body = {
                lab_analisis:this.analisis,
                lab_analisis_detalles:this.parametros
            }
            await this.axios.put(`${this.api}/lab_analisis/${this.analisis_id}`,body,this.cabeceras_json).then((res)=>{
                //console.log('Actualizacion Realizada',res.data.data);
            }).catch((e)=>{
                //console.log(e);
            });
        },

        async cargarParametrosMateriaPrima(){
            await this.axios.get(`${this.api}/lab_item_analisis/mp_tipos_id/${this.ticket.mp_tipos_id}/${this.tickets_id}`,this.cabeceras_json).then((res)=>{
                ////console.log(res.data.data)
                this.items_analisis = res.data.data;
                /* this.items_analisis.forEach(i=>{
                    i.parametros_activos.forEach(p=>{
                        p.valor = '';
                    });
                }) */
                //this.setearParametros();
            }).catch((e)=>{
                //console.log(e);
            });
        },

        

        async cargar_analisis(){
            if(this.tickets_id){
                await this.axios.get(`${this.api}/lab_analisis/obtener_analisis/${this.tickets_id}`,this.cabeceras_json).then((res)=>{
                    //console.log('lab_analisis',res.data.data);
                    this.analisis = res.data.data.lab_analisis;
                    this.detalles = res.data.data.lab_analisis_detalles;
                    this.ticket = res.data.data.ticket;
                    if(this.analisis != null){
                        this.analisis_id = this.analisis.id;
                        this.tickets_id = this.analisis.tickets_id;
                        this.guias_id = this.analisis.guias_id;
                    }else{
                        this.analisis_id = null;
                    }
                }).catch((e)=>{
                    //console.log(e);
                });
                await this.cargarParametrosMateriaPrima();
                await this.setearParametros();
                await this.cargar_guias();
            }else{
                this.ticket = null;
                this.analisis = null;
                this.items_analisis = [];
                this.detalles = [];
                this.guias = [];
            }
        },

        async subirArchivo($e,parametro){
            //console.log($e,parametro);

            this.file = $e.target.files[0];
            let formData = new FormData();
            formData.append('file', this.file);
            formData.append('lab_analisis_id',this.analisis.id);
            formData.append('lab_item_parametros_id',parametro.lab_item_parametros_id);

            await this.axios.post( `${this.api}/subir_archivo_analisis`,formData,this.cabeceras_archivo).then((res) => {
                //console.log('archivito',res.data.lab_analisis_detalle);
                
                let index = this.parametros.findIndex(p=>p.lab_item_parametros_id == parametro.lab_item_parametros_id);
                //console.log('parametro archivo',this.parametros[index]);
                this.$set(this.parametros[index],'id',res.data.lab_analisis_detalle.id);
                this.$set(this.parametros[index],'ruta_archivo',res.data.lab_analisis_detalle.ruta_archivo);
            })
            .catch((e)=>{
                //console.log(e);
                
            });
        },

        setearParametros(){
            this.parametros = [];
            this.items_analisis.forEach(item => {
                item.lab_item_parametros.forEach(par=>{
                    let det = this.detalles.find(d=>d.lab_item_parametros_id == par.id);
                    this.parametros.push({
                        id:det?det.id:null,
                        tipo_dato_texto:par.parametro.tipo_dato_texto,
                        lab_item_analisis_id:par.lab_item_analisis_id,
                        lab_analisis_id:this.analisis?this.analisis.id:null,
                        lab_item_parametros_id:par.id,
                        //valor:det?det.valor:'',
                        valor:det?Math.round10(det.valor, -1):'',
                        valor_texto:det?det.valor_texto:'',
                        ruta_archivo:det?det.ruta_archivo:'',
                        nombre:par.parametro.nombre,
                        unidad_medida_texto:par.parametro.unidad_medida_texto,
                        pasos_formulas:par.pasos_formulas,
                        maximo:par.maximo,
                        //valor_minimo:par.pivot.valor_minimo,
                        //valor_maximo:par.pivot.valor_maximo,
                        alerta:false
                    });
                })
            });
        },

        devolver_parametros(lab_item_analisis_id){
            return this.parametros_calculados.filter(p => p.lab_item_analisis_id == lab_item_analisis_id);
        }
    },
    computed:{

        mensaje_alert(){
            let devolver = [];
            Object.keys(this.errores).forEach(key => {
                  let array = this.errores[key];
                  array.forEach(mensaje => {
                      devolver.push(mensaje);
                  });
              });
            return devolver;
        },

        items(){
            let array = [];
            this.items_analisis.forEach(item => {

                let i = {
                    id:item.id,
                    nombre:item.nombre,
                    cantidad_parametros:item.cantidad_parametros
                }

                array.push(i);
            });

            return array;
        },

        parametros_calculados(){
            let array = [];
            this.parametros.forEach(par => {
                if(par.pasos_formulas.length > 0){
                    let valor_anterior = null;
                    let valor_final = null;
                    let setear = false;
                    par.pasos_formulas.forEach(paso=>{
                        let valor_1 = null;
                        let valor_2 = null;
                        if(paso.tipo_valor_1 == 'numero'){
                            valor_1 = paso.valor_1;
                        }
                        if(paso.tipo_valor_1 == 'resultado_anterior'){
                            valor_1 = valor_anterior;
                        }
                        if(paso.tipo_valor_1 == 'parametro'){
                            valor_1 = this.parametros.find(p=> p.lab_item_parametros_id == paso.lab_item_parametros_id1);
                            if(valor_1){
                                valor_1 = valor_1.valor;
                                //setear = true;
                            }
                        }


                        if(paso.tipo_valor_2 == 'numero'){
                            valor_2 = paso.valor_2;
                        }
                        if(paso.tipo_valor_2 == 'parametro'){
                            valor_2 = this.parametros.find(p=> p.lab_item_parametros_id == paso.lab_item_parametros_id2);
                            if(valor_2){
                                valor_2 = valor_2.valor;
                                //setear = true;
                            }
                        }
                        if(paso.tipo_valor_2 == 'resultado_anterior'){
                            valor_2 = valor_anterior;
                        }

                        //let resultado = null;
                        if(valor_1 && valor_2){
                            setear = true;
                        }

                        if(paso.operador == '+'){
                            valor_final = valor_1 + valor_2;
                        }

                        if(paso.operador == '-'){
                            valor_final = valor_1 - valor_2;
                        }

                        if(paso.operador == '*'){
                            valor_final = valor_1 * valor_2;
                        }

                        if(paso.operador == '/'){
                            valor_final = valor_1 / valor_2;
                        }

                        valor_anterior = valor_final; 
                        //valor_final = resultado;
                    });

                    //verificar que todos los que son parametro tengan un valor
                    if(setear){
                        par.valor = Math.round10(valor_final, -1);

                    }
                }
            });
            return this.parametros;
        },

        materia_prima(){
            return this.ticket != null? this.ticket.materia_prima_texto : ''
        },
        ...mapState(['api','cabeceras_json','cabeceras_archivo'])
    }
}
</script>